module.exports = __webpack_public_path__ + "img/Mascot_7.af2db5fe.png";